import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import AppPanel from '../fw/AppPanel.react';
import PagingGrid, {defaultPageSize, processPagingParams} from '../fw/PagingGrid.react';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'eventList.title', 'defaultMessage': 'Events'}
});

interface EventListProps {
    intl: IntlShape;
    relay?: object;
    user: User;
}

class EventList extends React.Component<EventListProps> {

    typeName = 'events';

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object,
        user: PropTypes.object.isRequired
    };

    render() {
        let { user } = this.props;
        let list = user.organisation.channel.events;
        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type: types['channels'], data: this.props.user.organisation.channel},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                    <PagingGrid
                        columns={['sourceDef.name', 'eventType', 'key', 'createdAt']}
                        edges={list}
                        metadata={type}
                        pageInfo={list.pageInfo}
                        relay={this.props.relay}
                        urlMapping={urlMapping} />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(EventList), (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        first: defaultPageSize,
        after: null,
        before: null,
        last: null,
    },
    prepareVariables (variables) {
        processPagingParams(variables);

		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        name,
                        channelDef {
                            id,
                            name
                        },
                        events(first: $first, after: $after, before: $before, last: $last) {
                            edges {
                                node {
                                    id,
                                    realId,
                                    organisation_id,
                                    channel_id,
                                    eventType,
                                    key,
                                    createdAt,
                                    sourceDef {
                                        id,
                                        name
                                    }
                                }
                            },
                            pageInfo {
                                hasNextPage,
                                hasPreviousPage,
                                startCursor,
                                endCursor
                            }
                        }
                    }
                }
            }
        `,
    },
});
